import InputText from "./InputText.vue";
import InputPhone from "./InputPhone.vue";
import InputDate from "./InputDate.vue";
import SingleSelect from "./SingleSelect.vue";
import SingleSelectV2 from "./SingleSelectV2.vue";
import Checkbox from "./Checkbox.vue";
import MultiSelect from "./MultiSelect.vue";
import InputTextarea from "./InputTextarea.vue";
import InputRadio from "./Radio.vue";
import InputCurrency from "./InputCurrency.vue";
import ToggleSwitch from "./ToggleSwitch.vue";

export { ToggleSwitch, InputText, InputPhone, InputDate, SingleSelect, SingleSelectV2, Checkbox, MultiSelect, InputTextarea, InputRadio, InputCurrency };


// WEBPACK FOOTER //
// ./src/components/Input/index.js